import moment from 'moment'

export const sortWatchListByDate = (watchList) => (
  watchList.sort((a,b) => {
    if(moment(a.createdAt, moment.ISO_8601).isAfter(moment(b.createdAt, moment.ISO_8601))) {return -1}
    if(moment(b.createdAt, moment.ISO_8601).isAfter(moment(a.createdAt, moment.ISO_8601))) {return 1}
    if(moment(b.createdAt, moment.ISO_8601)===moment(a.createdAt, moment.ISO_8601)) {return 0}
    return 1;
  })
);
export const sortWatchListAlphabetically = (watchList) => (
  watchList.sort((a,b) => {
    const name1 = a.name.replace(/\s/g, '');
    const name2 = b.name.replace(/\s/g, '');
    return name1.localeCompare(name2);
  })
);

export const sortWatchListByAmountDesc = (watchList) => (
  watchList.sort((a,b) => {
    let aMultiplier = a.yearToDate;
    let bMultiplier = b.yearToDate;
    if(a.yearToDate < 0) aMultiplier = -1 * a.yearToDate;
    if(b.yearToDate < 0) bMultiplier = -1 * b.yearToDate;
    if (aMultiplier < bMultiplier) { return 1 }
    if (aMultiplier > bMultiplier) { return -1 }
    if (aMultiplier === bMultiplier) { return 0 }
    return -1;
  })
);

export const sortWatchListByAmountAsc = (watchList) => (
  watchList.sort((a,b) => {
    let aMultiplier = a.yearToDate;
    let bMultiplier = b.yearToDate;
    if(a.yearToDate < 0) aMultiplier = -1 * a.yearToDate;
    if(b.yearToDate < 0) bMultiplier = -1 * b.yearToDate;
    if (aMultiplier < bMultiplier) { return -1 }
    if (aMultiplier > bMultiplier) { return 1 }
    if (aMultiplier === bMultiplier) { return 0 }
    return 1;
  })
);

export const sortWatchList = (swlData, swlOrder) => {
  if (!swlData) {
    return swlData;
  }
  switch (swlOrder) {
    case 'BY_DATE' :
      return sortWatchListByDate(swlData);
    case 'BY_ALPHABET':
      return sortWatchListAlphabetically(swlData);
    case 'BY_AMOUNT_DESC':
      return sortWatchListByAmountDesc(swlData);
    case 'BY_AMOUNT_ASC':
      return sortWatchListByAmountAsc(swlData);
    default :
      return sortWatchListByDate(swlData);
  }
};
